import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: "81893f43-dd0a-4da9-8b2c-a1b2f1bcdc04",
    /* You can enable or disable automatic data collection as needed */
    autoTrackPageVisitTime: true,
    enableAutoRouteTracking: true, // if using React Router
    enableSessionStorageBuffer: true,
    cookieCfg: {
      enabled: false,
    },
  },
});

export default appInsights;
